<template>
    <div>
    	<table class="room-table" cellspacing="0" v-if="!isLoading">
            <tbody>
                <tr style="text-align: left;vertical-align: top;">
                    <td class="roomType">{{rps.PriceTypeName+'&nbsp;&nbsp;'+"< " + rps.RatePlanName + " >"}}</td>
                    <td  class="roomStatus">
                        <p>房态</p>
                        <p>{{inpStatus?"房量":''}}</p>
                        <div style="height: 26px;"></div>
                        <p>{{inpPrice?"价格":''}}</p>
                        <p>{{inpRule?"取消规则":''}}</p>
                    </td>
                    <td :class="(getDaysSize(today,day.PD)>=0&&day.S!='026001'&&day.S)?'change-room roomItem close':'change-room roomItem'" v-for="day in tableData" @click="toRoomStatusSingleEdit(day)">
                        <div v-if="day" class="roomContent" style="cursor: default;">
                            <!-- <i v-if="getDaysSize(today,day.PD)>=0&&day.S!='026001'&&day.S"></i> -->
                            <div v-if="day.A" class="roomNum">
                                <p v-if="day.S=='026001'" class="roomOpen">已开房</p>
                                <p v-else-if="day.S&&day.S!='026001'" class="roomClose">已关房</p>
                                <p v-else class="roomWait">暂无房态</p>
                                <p style="min-height: 44px;">
                                    <span v-if="inpStatus" style="color: #a48cfd;"> R </span>
                                    <label class="Pab" v-if="day.O==false&&day.O!=null&&inpStatus">(不可超)</label>
                                    <span class="one Pab"  v-if="day.O&&inpStatus">(可超售)</span>
                                </p>
                            </div>
                            <div v-if="!day.A" class="roomNum">
                                <p v-if="day.S=='026001'" class="roomOpen">已开房</p>
                                <p v-else-if="day.S&&day.S!='026001'" class="roomClose">已关房</p>
                                <p v-else class="roomWait">暂无房态</p>
                                <p v-if="!day.IsShared" style="min-height: 44px;">
                                    <label class="size" v-show="day.SC!=null&&inpStatus">{{day.SC?day.SC:0}}</label>
                                    <label class="Pab" v-if="day.O==false&&day.O!=null&&inpStatus">(不可超)</label>
                                    <span class="one Pab" v-if="day.O&&inpStatus">(可超售)</span>
                                </p>
                                <p v-else style="min-height: 44px;">
                                    <label class="size" v-show="day.SSC!=null&&inpStatus">{{day.SSC?day.SSC:0}}</label>
                                    <label class="Pab" v-if="day.O==false&&day.O!=null&&inpStatus">(不可超)</label>
                                    <span class="one Pab" v-if="day.O&&inpStatus">(可超售)</span>
                                </p>
                            </div>
                            <p>
                                <label class="size">{{inpPrice?day.AP:''}}</label>
                            </p>
                           
                            <p v-show="!day.C" class="font10">
                                <label v-show="day.CD!=null&&inpRule">{{day.CD>0?day.CD +'天':'当天'}}</label>
                                <label v-show="day.CT&&inpRule">{{day.CT}}</label>
                            </p>
                            <p v-show="day.C&&inpRule"><span>不可取消</span></p>
                            <!-- <span class="day">{{getDateDay(day.PD)}}</span> -->
                        </div>
                        <div class="roomContent" v-else> </div>
                    </td>
                </tr>
            </tbody>
        </table>
 
    </div>

</template>
<script>


export default {
    name:'statusAndPriceTable',

    props:{
        rps:{
            type:Object,
            default:function(){
                return{}
            }
        },
        beginSlot:{
            type: String,
            default:''
        },
        inpPrice:{
            type: Boolean,
            default:true
        },
        inpStatus:{
            type: Boolean,
            default:true
        },
        inpRule:{
            type: Boolean,
            default:true
        },
        
    },
    data(){
        return{
            cmRps:{},
            tableData:'',
            cmSingleData: {},
            today:this.getDate(0),
            begin:this.getDate(0),
            isLoading:true
        }
    },
    watch:{
        beginSlot(val){
            this.begin = val
            this.initDate()
        },
        rps(val){
            console.log(val)
            this.cmRps=val;
            this.initTable();
        }
    },
    methods:{
        
        initDate(){
            var arr=[]
            var date =''
            for(var i = 0;i<=6; i++){
                if(i==0){
                    date = this.begin
                }else{
                    date = this.getNextDay(this.begin,i)
                }
                arr.push(date)
            }
            this.$emit('select',this.begin,arr)
            this.initTable()
        },
        //获取月份的数据
        initTable(){
            var that=this;
            var cmRps=that.cmRps;
            var params={
              hotel: cmRps.HotelId,
              room: cmRps.RoomId,
              rp: cmRps.RatePlanId,
              rate: cmRps.RateId,
              date: that.begin.replace(/-/g,''),
              endDate:that.getNextDay(that.begin,10).replace(/-/g,'')
            }
            that.isLoading = true;
            that.getRequest({
                url: that.Api.getRp,
                params: params
            }).then(res => {
                that.isLoading = false;
                if (res && res.length>0) {
                    that.tableData = res                 
                } else {
                    that.tableData='';
                    that.error({ title: '提示', content: '没有查询到相关数据' });
                }
            });
        },

       
        //获取日期中的天
        getDateDay(date){
            var date=date;
            var day=date.split('/')[2];
            return day

        },
        //编辑单独一天的房态
        toRoomStatusSingleEdit(day){
            if(this.getDaysSize(this.today,day.PD)<0)return;//先判断当期日期是否可以编辑
            this.cmSingleData=day;
            this.$nextTick(function () {
                this.$set(this.cmSingleData,'isShow',this.cmSingleData.isShow?false:true);
            });
        }
    },
    mounted(){
        this.cmRps=this.rps;
        this.initDate()
    }

}
</script>












// WEBPACK FOOTER //
// src/components/RoomPriceAndStatus/psComponent/table2.vue